<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :carpentryActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "Carpentrey",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name:
          "Carpentery/downloadaa9bbe04_storage_2femulated_2f0_2fDCIM_2fCamera_2fIMG_20170214_172559.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name:
          "Carpentery/downloadd69719a3_storage_2femulated_2f0_2fDCIM_2fCamera_2fIMG_20170214_172602.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "Carpentery/IMG-20170127-WA0001.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      }
    ],
    serviceTitle: "Carpentrey",
    serviceDescription:
      "Ceiling, roofing designs, flooring, windows and doors, decking and staircases."
  })
};
</script>
